import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const putAssignedClasses = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.DISTRIBUTE.PUT_ASSIGNED_CLASSES,
    data
  );
};

export default putAssignedClasses;
